import { render, staticRenderFns } from "./LandedCostCreateView.vue?vue&type=template&id=088c61aa"
import script from "./LandedCostCreateView.vue?vue&type=script&lang=js"
export * from "./LandedCostCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports